import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  private companyKey = 'companyId';
  private companySubject: BehaviorSubject<string | null>;

  constructor(
    private apollo: Apollo,
  ) {
    const savedCompany = sessionStorage.getItem(this.companyKey);
    this.companySubject = new BehaviorSubject<string | null>(savedCompany);
  }

  getCompaniesByUserId(userId: string, platformName: string) {
    const client = this.apollo.use('userPlatforms');

    const token = localStorage.getItem('token') || '';
    const headers: any = {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    };

    return client.query({
      query: gql`
      query FindAllByUserIdAndPlatformName($userId: ID!, $platformName: String!) {
        findAllByUserIdAndPlatformName(userId: $userId, platformName: $platformName) {
          allowedCompanies {
            id
            userId
            roleId
            status
            companyPlatform {
              id
              companyId
              platformId
              status
              company {
                id
                businessName
                nit
                email
                status
              }
              platform {
                id
                name
                domain
                status
              }
            }
            ipAccess {
              allowed
              policyEnabled
              reason
            }
          }
          restrictedCompanies {
            companyName
            reason
            message
          }
        }
      }
    `,
      variables: { userId: String(userId), platformName },
      context: { headers },
      fetchPolicy: 'no-cache'
    });
  }
}
